import { render, staticRenderFns } from "./PermissionListView.vue?vue&type=template&id=4f93a27a&scoped=true"
import script from "./PermissionListView.vue?vue&type=script&lang=js"
export * from "./PermissionListView.vue?vue&type=script&lang=js"
import style0 from "./PermissionListView.vue?vue&type=style&index=0&id=4f93a27a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f93a27a",
  null
  
)

export default component.exports